export default __webpack_public_path__ + "img/A8.b365c14b.svg";